(ns kyber.kyber-db.report-learner-data)

(defn ->ident-key
  [{activity-uuid :activity/uuid learner-uuid :user/uuid}]
  (str "activity-" activity-uuid "_learner-" learner-uuid))

(def model
  {:ident-key ->ident-key})
